<template>
  <div class="assign-account-type py-5 px-4 responsive-height">
    <v-container class="custom-container">
      <v-row dense class="no-gutters">
        <v-col cols="12">
          <v-card elevation="0" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-card-title class="px-0 large-title pt-0 pb-5">
              Here you can see PARENT IB only but, When you assign him, all
              people under that PARENT Will be Included.
            </v-card-title>
            <v-row>
              <v-col cols="12" lg="9">
                <ib-assign :allAccountTypes="allAccountTypes" :allMasterIB="allMasterIB" :countries="countries"
                  @updateCheckboxStatus="updateCheckboxStatus"
                  @updateSelectedPartners="updateSelectedPartners"></ib-assign>
              </v-col>
              <v-col cols="12" lg="3">
                <account-type-chips :allAccountTypes="allAccountTypes" :isCheckedAny="isCheckedAny"
                  :selectedPartners="selectedPartners"></account-type-chips>
              </v-col>
              <v-col cols="12" lg="12">
                <assign-account-type-data-table
                  :allMasterIBDataTable="allMasterIBDataTable" :allAccountTypesDataTable="allAccountTypesDataTable"
                  :countries="countries">
                </assign-account-type-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import IbAssign from '@/components/Partners/IbAssign.vue';
import AccountTypeChips from '@/components/Partners/AccountTypeChips.vue';
import AssignAccountTypeDataTable from '@/components/Partners/AssignAccountTypeDataTable.vue';
import { mapActions, mapState } from "vuex";
import { ASSIGNACCTYPE__ACTIONS } from "@/store/action-types";

export default {
  components: { IbAssign, AccountTypeChips, AssignAccountTypeDataTable },
  data() {
    return {
      isCheckedAny: false,
      selectedPartners: []
    }
  },
  computed: {
    ...mapState("assignacctype", ['allMasterIB', 'allAccountTypes', 'allMasterIBDataTable', 'allAccountTypesDataTable', 'countries']),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("assignacctype", [
      ASSIGNACCTYPE__ACTIONS.ALLMASTERIB,
      ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE,
      ASSIGNACCTYPE__ACTIONS.UNIQUECOUNTRIES
    ]),

    updateCheckboxStatus(status) {
      this.isCheckedAny = status;
    },
    updateSelectedPartners(partners) {
      this.selectedPartners = partners;
    },
  },
  async mounted() {
    await this[ASSIGNACCTYPE__ACTIONS.UNIQUECOUNTRIES]();
    await this[ASSIGNACCTYPE__ACTIONS.ALLMASTERIB]();
    await this[ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE]();
  },
};
</script>
